
import Vue from "vue";
import {ObservationType}from "@/utils/carpass/observation";
import { ISelectItem } from "winfakt-vue-components";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import { CarpassInputModalState } from "@/utils/carpass-input-modal-state";
import AppErrorMessageBox from "@/components/common/ErrorMessageBox.vue";
import AppCarpassObservationDescriptionModal from "./CarpassObservationDescriptionModal.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>CarpassInputModalState,
			required: true
		}
	},
	computed: {
		observationTypes():ISelectItem<ObservationType>[]{
			return getEnumKeys(ObservationType).map(v=>{
				return {
					text: this.$ct(`carpass-observation-type.${v}`),
					value: getEnumValueFromKey(ObservationType, v)
				} as ISelectItem<ObservationType>;
			});
		},
		showIssues():boolean{
			return this.state.issues.length > 0;
		}
	},
	methods: {
		cancel(){
			this.state.cancel();
		},
		confirm(){
			this.state.confirm();
		}
	},
	components: {
		AppErrorMessageBox,
		AppCarpassObservationDescriptionModal
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
